export const environment = {
  production: true,
  apiUrl: 'https://globalassethub-qa.sonypictures.com/gahapi',
  baseUrl: 'https://globalassethub-qa.sonypictures.com',
  stripoPluginStaticSource: 'https://plugins.stripo.email/static/latest/stripo.js',
  stripoPluginAuth : 'https://plugins.stripo.email/api/v1/auth',
  okta: {
    issuer: 'https://spe.oktapreview.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://globalassethub-qa.sonypictures.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://globalassethub-qa.sonypictures.com'
  },
  oktapublicity: {
    issuer: 'https://spe.oktapreview.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://qa.sonypicturespublicity.net/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://qa.sonypicturespublicity.net'
  },
  oktapublicityaus: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespublicity.com.au/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com.au'
  },
  oktapublicitydotcom: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com'
  },
  oktapublicityfr: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespresse.fr/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespresse.fr'
  },
  oktapublicitynz: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespublicity.co.nz/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.co.nz'
  },
  oktapublicity1: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://sonypicturespublicity.com'
  },
  captchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  gtmId: 'GTM-54NFTQ9B',
  gtmId_ns: 'GTM-PPVFC757',
  gtmScriptUrl: 'https://www.googletagmanager.com/gtm.js',
  gtmNoScriptUrl: 'https://www.googletagmanager.com/ns.html'
};